// extracted by mini-css-extract-plugin
export default {"upgradePlan":"UpgradePlan_upgradePlan__LXC7h","content":"UpgradePlan_content__Ogu9D"};